import React from 'react';

interface ProgressBarProps {
  completed: number;
  total: number;
}

export function ProgressBar({ completed, total }: ProgressBarProps) {
  const percent = total === 0 ? 0 : Math.round((completed / total) * 100);
  const isComplete = total > 0 && percent === 100;
  const fillColor = isComplete ? '#c9a84c' : '#1a6b3c';

  return (
    <div style={styles.wrapper}>
      <div style={styles.container}>
        <div
          style={{
            ...styles.fill,
            width: `${percent}%`,
            backgroundColor: fillColor,
          }}
        />
      </div>
      <span style={styles.label}>
        {completed}/{total} steps
      </span>
    </div>
  );
}

const styles: Record<string, React.CSSProperties> = {
  wrapper: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
  },
  container: {
    flex: 1,
    height: '8px',
    backgroundColor: '#e0e0e0',
    borderRadius: '4px',
    overflow: 'hidden',
  },
  fill: {
    height: '100%',
    borderRadius: '4px',
    transition: 'width 0.3s ease',
  },
  label: {
    fontSize: '12px',
    color: '#555',
    whiteSpace: 'nowrap',
  },
};
